<template>
  <div class="pbf grid_width">
 

    <div class="">
      <template v-for="pro in data">
        <BrandSchemeItem
          :scheme="pro"
          />
      </template>
    </div>
  

  </div>
</template>




<script setup lang="ts">

interface Props {
  inurl: string
}

const props = defineProps<Props>()

const { $api } = useNuxtApp()

const loadResults = async function(){
  const dt = await $api.getUrl(props.inurl, {})
  return dt
}

const { status: dataStatus,  data: data } = await useLazyAsyncData('giveawaysData', loadResults)

</script>
 

<style scoped>



</style>
